<template>
  <dx-document-upload-form
    next-step-path="SelfService-ReportDamage-Deadline"
    previous-step-path="SelfService-ReportDamage-Facts"
  />
</template>

<script>
import DxDocumentUploadForm from '~/components/reportDamage/DX-DocumentUploadForm'

export default {
  name: 'ReportDamageDocumentUpload',
  components: {
    DxDocumentUploadForm,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/kundencenter/schaden-melden/dokumentenupload',
      fr: '/centre-clients/dommages-rapport/telecharger-un-document',
      it: '/cliente/danni-report/carica-documento',
    },
  },
}
</script>
